export default __webpack_public_path__ + "static/media/instagram-icon.cfd9e3ce.svg";